export const GlobalMenu = {
  MAIN_NAVIGATION: 'MAIN_NAVIGATION',
  PAL: 'PAL',
  INSTANT_SEARCH: 'INSTANT_SEARCH',
} as const;

export const GlobalMenuState = {
  ...GlobalMenu,
  NONE: 'NONE',
} as const;

export type GlobalMenu = (typeof GlobalMenu)[keyof typeof GlobalMenu];
export type GlobalMenuState = (typeof GlobalMenuState)[keyof typeof GlobalMenuState];
